import { SocialNetwork } from './types';

// TODO: This file needs to be migrated to a `en.json`

export const replacements = {
    socialNetwork: '{socialNetwork}',
    submitHelpAction: '{submitHelpAction}',
};

export const i18n = {
    itemLabel: {
        editMode: {
            custom: 'Edit custom URL',
            social: `Edit ${replacements.socialNetwork} URL`,
        },
        viewMode: {
            custom: 'Visit external website',
            social: `Visit ${replacements.socialNetwork} profile`,
        },
    },
    addItemLabel: 'Add new social item',
    // cancelItemLabel: 'Cancel changes to this link',
    // TODO: We should have a distinciton for when a "delete action"
    // will simply cancel/close the item vs actually delete it.
    deleteItemLabel: 'Delete the currently selected link from your profile',
    submitItemLabel: 'Submit changes to this link',
    // escapeItemLabel: 'Press "Escape" to cancel changes to this link',
    // enterItemLabel: 'Press "Enter" to submit changes to this link',
    // TODO: Do we want a "Edit/change *" as well?
    inputLabel: {
        addLink: 'Add social link',
        addHandle: `Add ${replacements.socialNetwork} handle`,
        // TODO: This is likely never reached.
        addHandleFallback: 'Add social handle',
    },
    submitHelpAction: 'Enter',
    submitHelpText: `Press ${replacements.submitHelpAction} to confirm`,
    placeholder: {
        custom: 'Enter a social URL',
        // TODO: Can we simply do `${replacements.socialNetwork} handle`?
        [SocialNetwork.Discord]: 'Discord handle',
        [SocialNetwork.Facebook]: 'Facebook page',
        [SocialNetwork.Instagram]: 'Instagram handle',
        [SocialNetwork.LinkedIn]: 'LinkedIn handle',
        [SocialNetwork.TikTok]: 'TikTok handle',
        [SocialNetwork.Twitch]: 'Twitch handle',
        [SocialNetwork.Twitter]: 'Twitter handle',
        [SocialNetwork.YouTube]: 'YouTube channel',
    },
};
